//Scroll left and right, when click on blue btn in price page table links navigation

$('.table__scroll-right').click(function () {
	$(this).parent().next(".tab").find('.tab__content').find('.table').animate({
		scrollLeft: $(this)
						.parent()
						.next(".tab")
						.find('.tab__content')
						.find('.table')
						.scrollLeft() + 50
	}, 300);
});

$('.table__scroll-left').click(function () {
	$(this).parent().next(".tab").find('.tab__content').find('.table').animate({
		scrollLeft: $(this)
						.parent()
						.next(".tab")
						.find('.tab__content')
						.find('.table')
						.scrollLeft() - 50
	}, 300);
});